// @ts-nocheck
import { SPELLS } from "../../data";
import { TAU, clamp } from "../../util";
import { Game } from "../game-base";

Game.prototype.drawStickyMines = function () {
  const c = this.ctx;
  const col = (SPELLS.scourge && SPELLS.scourge.color) || "#ff5d3a";
  for (const sm of this.stickymines || []) {
    const r = sm.r || (SPELLS.scourge && SPELLS.scourge.range) || 165;
    const pulse = 0.5 + 0.5 * Math.sin((sm.pulse || 0) * (sm.chase ? 10 : 4));
    const chasing = !!sm.chase;
    c.save();
    c.translate(sm.x, sm.y);
    c.fillStyle = chasing
      ? `rgba(255, 120, 60, ${0.12 + 0.1 * pulse})`
      : `rgba(255, 93, 58, ${0.08 + 0.07 * pulse})`;
    c.beginPath();
    c.arc(0, 0, r, 0, TAU);
    c.fill();
    c.strokeStyle = chasing
      ? `rgba(255, 170, 90, ${0.35 + 0.25 * pulse})`
      : `rgba(255, 120, 80, ${0.22 + 0.18 * pulse})`;
    c.lineWidth = chasing ? 2.5 : 1.5;
    c.setLineDash(chasing ? [] : [6, 7]);
    c.beginPath();
    c.arc(0, 0, r, 0, TAU);
    c.stroke();
    c.setLineDash([]);
    c.fillStyle = chasing ? "#ffb060" : col;
    c.shadowColor = col;
    c.shadowBlur = chasing ? 16 * pulse : 8 * pulse;
    c.beginPath();
    c.arc(0, 0, chasing ? 10 + pulse * 2 : 8, 0, TAU);
    c.fill();
    if (chasing && sm.ti != null && this.playerById[sm.ti]) {
      const t = this.playerById[sm.ti];
      c.strokeStyle = `rgba(255, 200, 120, ${0.35 + 0.25 * pulse})`;
      c.lineWidth = 2;
      c.setLineDash([4, 5]);
      c.beginPath();
      c.moveTo(0, 0);
      c.lineTo(t.x - sm.x, t.y - sm.y);
      c.stroke();
      c.setLineDash([]);
    }
    c.restore();
  }
};
